/** @jsxImportSource @emotion/react */
import React from "react";
import { getApplicationIconById } from "components/application-icon/ApplicationIcon";
import { css } from "@emotion/react";

const styles = {
  applicationHeader: css`
    background-color: #dadde0;
    padding: 4px 0px 2px 6px;
    display: flex;
    justify-content: space-between;
    line-height: 18px;
  `,

  logoBlock: css`
    display: block;
    float: left;
  `,

  applicationTitle: css`
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
    vertical-align: top;
    line-height: 32px;
  `,

  expandAll: css`
    display: block;
    margin-right: 15px;
    background-color: transparent;
    border: none;
    cursor: pointer;
  `,

  rpExpandHandle: css`
    display: block;
    float: right;
    height: 15px;
    width: 15px;
    margin: 5px 5px 0 5px;
    list-style-position: outside;
    list-style: none;
    background-position: 0 -5px;
    background-color: transparent;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAH0CAMAAAAdRm3AAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjhGRUI3OTFCQUJDNTExRTA5RUUzODAzNkE5RkY3RDc2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjhGRUI3OTFDQUJDNTExRTA5RUUzODAzNkE5RkY3RDc2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OEZFQjc5MTlBQkM1MTFFMDlFRTM4MDM2QTlGRjdENzYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OEZFQjc5MUFBQkM1MTFFMDlFRTM4MDM2QTlGRjdENzYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5DE7X0AAAAkFBMVEWkq7Lz1kr89dnh4+Xd4OPf4eTu7/Hv8fLs7u/j5Ofr7O764YVjZWf866/c3uH7553755/878D75ZP76abx8vP644v65JHl5ulfYGJnaWvn6Orp6uxvcXNaW11xc3X64odrbW9WV1mts7n02ltMTU/02l356qhSU1XX2t23vcJOT1H57K2utLr233DLztMAAAC+iU5ZAAAAMHRSTlP//////////////////////////////////////////////////////////////wBipdB4AAABYElEQVR42uzay1KDQBCF4Um8xsG7RiIkCpiYmAvv/3ZOD5BuNpblJpb+ZxFovgKqmKxOjau/jDsobweabV2vnGZVu2ox1CyqcvmgWZZuMLzXDAfuzMYFvtYEPrURvtMEPrcRftQEvrAR9n42m+Wvk8T7wFmWtWM4a9jLlPrIzyFxlBPhl5Akncoh8JMkjPEoPJYU8TfwKKZoDsI3msBHNsKXmsAnNsK3msDHNs7N1+abr+eb3ZVmt3F1ZVasquvSrFh54D8TDMMwDMMwDMMwDMMwDP9x/vV9at7vU3Pbp3of29SuT82ypk3d96mTJJ0W2qfGUftUmd4/3ro+tR1tnzru96kj+lQYhmEYhmEYhmEYhmH4H3G7f7G7Zsbm7rh/Ue/RsX14kk7tM/dj9+6i/86Cbw7DMAzDMAzDMAzD8Lc571/O+2wqjd7YcNxEpKqjazsM2URkKo1uZEl+wp8CDAAMVkVPMF/q0wAAAABJRU5ErkJggg==");
    background-repeat: no-repeat;

    &:hover {
      background-position: 100% -5px;
    }
  `,

  rpExpanded: css`
    background-position: 0 -181px;

    &:hover {
      background-position: 100% -181px;
    }
  `,

  clearFix: css`
    clear: both;
  `
};

export const ApplicationHeader = ( { applicationId, title, isEnabled, isAllExpanded, onToggleExpanded }: { applicationId: number; title: string; isEnabled: boolean; isAllExpanded: boolean; onToggleExpanded: () => void; } ): JSX.Element => {
  return ( <>
    <div css={ styles.applicationHeader }>
      <div css={ styles.logoBlock }>
        <span><img alt="Logo" src={ getApplicationIconById( applicationId ) } /></span>
        <span css={ styles.applicationTitle }>{ title }</span>
      </div>
      <button type="button" css={ styles.expandAll } disabled={ !isEnabled } onClick={ () => onToggleExpanded() } >
        <span css={ css`line-height: 25px;` }>{ isAllExpanded ? "Collapse all" : "Expand all" }</span>
        <span css={ [ styles.rpExpandHandle, isAllExpanded ? styles.rpExpanded : undefined ] }></span>
      </button>
    </div>
  </> );
};
